const qs = require('qs')
const axios = require('axios').default

const getApiUrl = (req) => {
  let reqModel = {
    version: 1.0,
    controller: null,
    action: null,
    queryString: null
  }
  Object.assign(reqModel, req)
  // console.log(reqModel, req)
  let host = '/backend'
  if (reqModel.host) {
    host = reqModel.host
  }
  let baseUrl = `${host}` // 甘肃-需要IIS做反向代理
  // console.log(baseUrl)
  let url = `${baseUrl}/${reqModel.controller}/${reqModel.action}`
  if (reqModel.queryString && Object.keys(reqModel.queryString).length != 0) {
    let queryString = reqModel.queryString
    if (reqModel.queryString instanceof Object) {
      // console.log(_self, _self.$qs)
      queryString = qs.stringify(reqModel.queryString)
    }
    url += '?' + queryString
  }
  return url
}

const request = (req) => {
  return new Promise((resolve, reject) => {
    let reqModel = {
      method: null,
      // version: 1.0,
      timeout: 15 * 1000,
      controller: null,
      action: null,
      queryString: null,
      data: null,
      options: null,
      auth: true
    }
    let options = {}
    Object.assign(options, req.options)
    Object.assign(reqModel, req)
    let url = getApiUrl(reqModel)
    axios.request({
      url: url,
      method: reqModel.method || 'POST',
      headers: options.headers,
      data: reqModel.data,
      withCredentials: true
    }).then((res) => {
      if (!res.data.success) {
        // let errorCode = res.data.code
        let errorMsg = res.data.message
        reject(new Error(errorMsg))
      } else {
        if (res.data.data !== null && res.data.data !== undefined) {
          resolve(res.data.data)
        } else {
          resolve(res.data)
        }
      }
    }).catch((err) => {
      console.log(err, err.config)
      reject(new Error(err.response.data.message))
    })
  })
}

const requestRaw = async (req) => {
  let reqModel = {
    method: null,
    timeout: 15 * 1000,
    controller: null,
    action: null,
    queryString: null,
    data: null,
    options: null,
    auth: true
  }
  let options = {}
  Object.assign(options, req.options)
  Object.assign(reqModel, req)
  let url = getApiUrl(reqModel)
  return await axios.request({
    url: url,
    method: reqModel.method || 'POST',
    headers: options.headers,
    data: reqModel.data,
    withCredentials: reqModel.auth,
    responseType: req.responseType
  }).then((res) => {
    return Promise.resolve(res)
  }).catch((err) => {
    console.log(err, err.config)
    return Promise.reject(new Error(err.response.data.message))
  })
}

module.exports = {
  request,
  requestRaw,
  getApiUrl
} 
